const movies = [
  { name: "popular" },
  { name: "Now playing" },
  { name: "UP COMING" },
  { name: "Top Rated" },
];

const tvShows = [
  { name: "popular" },
  { name: "Airing Today" },
  { name: "On TV" },
  { name: "Top Rated" },
];

const people = [{ name: "popular People" }];

const more = [
  { name: "Dicussions" },
  { name: "LeaderBoard" },
  { name: "Support" },
  { name: "API" },
];

export const menuItems = [
  { id: "menu-btn-1", items: movies },
  { id: "menu-btn-2", items: tvShows },
  { id: "menu-btn-3", items: people },
  { id: "menu-btn-4", items: more },
];
